/** Tester review 2026-09-28 — English translation of uiStrings.v2.es.ts. */
export const V2_EN: Record<string, string> = {
  // Home
  'home.heading': 'Do you have a question, suggestion or concern about the Project?',
  'home.subheading': 'We want to hear from you.',
  'home.intro': 'This is the channel of the “Jubilación Segura” Project to ask questions, share suggestions, voice concerns or submit complaints and grievances related to its activities, impacts, benefits or implementation.',
  'home.mechanism': 'All communications will be received and assessed in line with the Project’s Grievance Mechanism.',
  'home.privacy': 'Your privacy matters to us. You can submit your request anonymously. If you choose to provide personal data, it will only be used to handle your request and to contact you, in line with our Data Protection Policy.',
  'home.start': 'Start a request',

  // Type of record
  'form.type.heading': 'How do you want to submit your request?',
  'form.type.identified.title': 'I want to leave my contact details',
  'form.type.identified.desc': 'You register your personal and contact details (for example name and phone). The Project team may contact you while your request is assessed and to give you an answer.\nYou will be able to check the status of your request with the tracking code.',
  'form.type.anonymous.title': 'I want my request to stay anonymous',
  'form.type.anonymous.desc': 'You do not need to give personal data. Your request will be received and assessed in line with the Project’s Grievance Mechanism. Without contact details we cannot contact you directly or send you a personal answer.\nYou can use your tracking code to check the status of your request.',

  // Requester
  'form.requester.heading': 'How can we contact you?',
  'form.requester.notice': 'This information lets us contact you to follow up on your request and give you an answer.',
  'form.requester.fullName': 'Name and surname / Organisation name',
  'form.requester.gender': 'Gender',
  'form.requester.gender.M': 'Man',
  'form.requester.gender.F': 'Woman',
  'form.requester.contactPrompt': 'How would you like us to contact you?',
  'form.requester.phone': 'Phone / WhatsApp',
  'form.requester.phonePlaceholder': 'E.g. 999 999 999',
  'form.requester.email': 'E-mail',
  'form.requester.emailPlaceholder': 'E.g. name@mail.com',
  'form.requester.contactHint': 'Give at least one way to contact you.',
  'form.requester.idHeading': 'Identity document (optional)',
  'form.requester.idDocumentType': 'Document type',
  'form.requester.id.RUC': 'RUC (legal entity)',
  'form.requester.idNotice': 'You do not need to provide an identity document to submit a request. If you do, it will only be used to handle your request, in line with the Data Protection Policy.',

  // Request
  'form.request.heading': 'What would you like to tell the Project?',
  'form.request.headingHelp': 'If you are not sure which to pick, choose the option closest to your situation.',
  'form.request.category': 'Type of request',
  'category.CONSULTA': 'Question or request for information',
  'category.SUGERENCIA': 'Suggestion or proposal',
  'category.PREOCUPACION': 'Concern or alert',
  'category.QUEJA_RECLAMO': 'Complaint or grievance',
  'form.request.categoryHelp.CONSULTA': 'I want to ask a question, clarify a situation or request information about the Project.',
  'form.request.categoryHelp.SUGERENCIA': 'I want to share an idea, recommendation or proposal to improve the Project’s activities.',
  'form.request.categoryHelp.PREOCUPACION': 'I want to report a situation that worries me and that the Project should know about or review.',
  'form.request.categoryHelp.QUEJA_RECLAMO': 'I want to express my disagreement or dissatisfaction with a situation, activity, decision or impact related to the Project. What happened? When? Where? Who is involved?',
  'form.request.descTitle': 'Tell us about your request',
  'form.request.descLabel.CONSULTA': 'What information do you need or what would you like clarified?',
  'form.request.descLabel.SUGERENCIA': 'What proposal or improvement would you like to share?',
  'form.request.descLabel.PREOCUPACION': 'What situation concerns you?',
  'form.request.descLabel.QUEJA_RECLAMO': 'What happened and what is your concern?',
  'form.request.descHint.CONSULTA': 'At least 10 characters. Tell us what you want to know or which aspect of the Project you want clarified.',
  'form.request.descHint.SUGERENCIA': 'At least 10 characters. Tell us your idea or proposal and how you think it could help.',
  'form.request.descHint.PREOCUPACION': 'At least 10 characters. Tell us what worries you, where it happened and why you think we should look into it.',
  'form.request.descHint.QUEJA_RECLAMO': 'At least 10 characters. Tell us what happened, when and where, and what you think should be addressed.',
  'form.request.expectation': 'If you wish, tell us what you expect the Project to do to address this situation.',

  // Relationship with the project
  'relation.heading': 'To help us understand your request (optional)',
  'relation.type': 'What is your relationship with the Project?',
  'relation.subtype': 'Specify your relationship',
  'relation.other': 'Describe your relationship with the Project',
  'relation.type.PARTICIPANTE_COMUNIDAD': 'Participant or community',
  'relation.type.ORGANIZACIONES_PROVEEDORES': 'Organisations and suppliers',
  'relation.type.INSTITUCIONES_OTROS': 'Institutions and other actors',
  'relation.type.OTRO': 'Other',
  'relation.type.NO_ESPECIFICA': 'Prefer not to say',
  'relation.sub.PRODUCTOR_PARTICIPANTE': 'Participating producer',
  'relation.sub.MIEMBRO_COMUNIDAD': 'Member of a local community',
  'relation.sub.VECINO_AFECTADO': 'Neighbour or potentially affected person',
  'relation.sub.ORG_SOCIA': 'Representative of a partner organisation of the project',
  'relation.sub.ORG_LOCAL': 'Representative of a local organisation',
  'relation.sub.PROVEEDOR_CONTRATISTA': 'Supplier or contractor',
  'relation.sub.TRABAJADOR_PROYECTO': 'Worker or collaborator of the Project',
  'relation.sub.AUTORIDAD_PUBLICA': 'Public authority or institution',
  'relation.sub.SOCIEDAD_CIVIL': 'Civil society organisation',
  'relation.sub.TITULAR_TIERRAS': 'Landowner or land-rights holder',

  // Files
  'files.heading': 'Do you have a photo, document or evidence you would like to share?',
  'files.add': 'Attach a photo or document',
  'files.hint': 'JPG, PNG or PDF · Maximum {max} MB',

  // Location
  'form.location.heading': 'Where did it happen or what place does your request refer to?',
  'form.location.intro': 'Indicate the place related to your request. You can select a community, locality or area of the Project.',
  'form.location.sector': 'Sector, hamlet or community',
  'loc.region': 'Region of the Project area',
  'loc.province': 'Province of the Project area',
  'loc.district': 'District of the Project area',
  'loc.otherRegion': 'Other',

  // Review
  'form.review.heading': 'Review your request before sending it',
  'form.review.anonymousBadge': 'Anonymous request',
  'form.review.identifiedBadge': 'Request with contact details',
  'form.review.verify': 'Check that the information is correct. If you need to change anything you can go back before sending.',
  'form.review.contactTitle': 'Your contact details',
  'form.review.requestTitle': 'Your request',
  'form.review.type': 'Type',
  'form.review.description': 'Description',
  'form.review.location': 'Place related to the request',
  'form.review.files': 'Attached files',
  'form.review.filesCount': '{n} file(s)',
  'form.review.noFiles': 'None',
  'form.review.relation': 'Relationship with the Project',
  'form.review.consentTitle': 'Processing of personal data',
  'form.review.consentText': 'I have read the information about the use and protection of my personal data.',
  'form.review.consentAnonymousText': 'I confirm that I want to send this request anonymously.',
  'form.review.anonymousInfo': 'By sending an anonymous request, your personal contact details will not be recorded. We will therefore not be able to contact you directly or send you a personal answer.',
  'form.review.identifiedInfo': 'By providing your contact details, we can reach you if we need more information and give you an answer about your request.',
  'form.review.trackingInfo': 'You will receive a tracking code to check the status of your request.',
  'form.submit': 'Send request',

  // Confirmation
  'success.heading': 'Your request has been received!',
  'success.thanks': 'Thank you for contacting the Jubilación Segura Project.',
  'success.keepCode': 'Keep this code somewhere safe. You will need it to check the status of your request.',
  'success.whatNow': 'What can you do now?',
  'success.track': 'Check the status of my request',
  'success.another': 'Submit another request',
  'success.uploadFailed': '{n} file(s) could not be uploaded. You can try attaching them again here.',

  // Errors
  'error.contactRequired': 'Give at least a phone number or an e-mail.',
  'error.dateInFuture': 'The date cannot be in the future.',
  'error.CONTACT_REQUIRED': 'Give at least a phone number or an e-mail.',
  'error.ID_DOCUMENT_INCOMPLETE': 'Give both the document type and number, or neither.',
  'error.RELATION_OTHER_REQUIRED': 'Describe your relationship with the Project.',
  'error.RELATION_SUBTYPE_REQUIRED': 'Specify your relationship with the Project.',
  'error.ORG_NOT_IN_PROJECT': 'That organisation does not belong to the selected project.',
  'error.DATE_IN_FUTURE': 'The date cannot be in the future.',
  'error.RECEPTION_EVIDENCE_REQUIRED': 'Give the kind of reception evidence.',
  'error.RECEPTION_RECORD_REQUIRED': 'Complete the internal reception record.',
  'error.TEAM_REQUIRED': 'Enter at least one member of the project technical team.',
  'error.REPORTER_NAME_REQUIRED': 'Enter the name of the person registering.',
  'error.OTHER_PLACE_REQUIRED': 'Detail the place of the event.',
  'error.ORG_NOT_ALLOWED_FOR_EVENTS': 'That entity cannot report events.',

  // Organisations, channels, places, proofs
  'org.FLOR_DE_CAFE': 'FLOR DE CAFE',
  'org.VALLE_VERDE': 'VALLE VERDE',
  'org.APROEXPORT': 'APROEXPORT',
  'org.APROCOYCE': 'APROCOYCE',
  'channel.ONLINE_FORM': 'Online form',
  'channel.MAILBOX': 'MACQR physical mailboxes (partner organisations or nurseries)',
  'channel.COMPLAINTS_BOOK': 'Complaints book (partner organisations or nurseries)',
  'channel.EMAIL': 'E-mail',
  'channel.WEBSITE': 'Website',
  'channel.EVENT_BOX': 'MACQR box at events',
  'channel.PAPER_FORM': 'Paper form collected during technical field visits',
  'channel.PHONE_CALL': 'Phone call',
  'channel.IN_PERSON': 'In-person service',
  'place.OFICINA_SOCIOS': 'Partner organisations’ office',
  'place.OFICINA_VIVEROS': 'Nurseries’ office',
  'place.COMUNIDAD': 'Community or settlement',
  'proof.FORMATO_MACQR': 'MACQR paper form (scanned photo)',
  'proof.CORREO_REGISTRO_WEB': 'Screenshot/PDF of the e-mail or web entry received',
  'proof.LIBRO_ACTAS': 'Photo or scan of the complaints book or meeting minutes',
  'proof.CAPTURA_MENSAJE': 'Screenshot of a received message (phone)',
  'proof.REGISTRO_INTERNO': 'Internal reception record',
  'proof.OTRO': 'Other',

  // Internal form
  'internal.heading': 'Register a request received through another channel',
  'internal.intro': 'Internal form that adds to the system a question, suggestion, complaint or grievance received by the Project through another channel.',
  'internal.section.origin': 'Reception details',
  'internal.section.originHelp': 'Record how and when the request was received by the Project. This lets us follow its origin and entry channel.',
  'internal.who': 'Who is registering?',
  'internal.registeredByName': 'Name of the project staff member registering the request',
  'internal.registeredByEmail': 'E-mail of the project staff member registering the request',
  'internal.registeredByOrg': 'Organisation / team that received it',
  'internal.how': 'How the request arrived',
  'internal.channel': 'Entry channel',
  'internal.receptionPlace': 'Place or point of reception',
  'internal.presentedAt': 'Reception date',
  'internal.presentedAtHint': 'Date on which the Project first received the request.',
  'internal.registeredAt': 'Date registered in the system',
  'internal.automatic': 'Automatic',
  'internal.proof.heading': 'Evidence of reception',
  'internal.proof.question': 'Do you have a file that proves the reception?',
  'internal.proof.yes': 'Yes → attach the file (mandatory)',
  'internal.proof.no': 'No → complete the internal reception record (mandatory)',
  'internal.proof.kind': 'Kind of evidence',
  'internal.proof.attachHelp': 'Attach a file that shows how this request was received.',
  'internal.proof.attach': 'Attach evidence',
  'internal.proof.formats': 'Photo, screenshot, PDF, document. Allowed formats: JPG, PNG, PDF · Maximum size: {max} MB',
  'internal.proof.examples': 'Examples: photo of the MACQR paper form received in a mailbox, at events or technical visits; screenshot of an e-mail or message; photo of a page of the complaints book or any other document proving reception.',
  'internal.proof.required': 'Attach at least one file proving the reception.',
  'internal.record.heading': 'Internal reception record',
  'internal.record.help': 'Complete this section when the request was received verbally or when no document or file proves its reception.',
  'internal.record.date': 'Reception date',
  'internal.record.time': 'Reception time',
  'internal.record.medium': 'Reception medium',
  'internal.record.by': 'Person who received the request',
  'internal.record.role': 'Position or role',
  'internal.record.description': 'How was the request received?',
  'internal.record.descriptionHint': 'Briefly describe how the request was received, who presented it and in what context. Example: the requester verbally expressed their concern during a technical team visit to the community.',
  'internal.record.saved': 'Once saved, this record is attached to the request as evidence of reception.',
  'internal.person.heading': 'Requester details',
  'internal.person.question': 'Did the requester provide their details?',
  'internal.person.yes': 'Yes, they left their details',
  'internal.person.no': 'No, the request is anonymous',
  'internal.person.idNotice': 'An identity document is not required to submit the request.',
  'internal.relation.heading': 'Relationship with the project',
  'internal.relation.question': 'What is the requester’s relationship with the Project?',
  'internal.desc.heading': 'Description of the request',
  'internal.desc.help': 'Record what the requester said as clearly and objectively as possible.',
  'internal.desc.label': 'What did the requester communicate?',
  'internal.desc.hint': 'At least 10 characters. If known, say what happened, when and where. If known, say what solution they expect.',
  'internal.desc.files': 'Do you have a photo, document or evidence the requester shared with their request?',
  'internal.location.heading': 'Place related to the request',
  'internal.location.help': 'It does not need to be the requester’s home: indicate the place the request refers to.',
  'internal.consent': 'I confirm that the requester was informed about the processing of their personal data and gave consent on the physical record (or through the channel they used).',
  'internal.submit': 'Register request',
  'internal.done.heading': 'Request registered successfully!',
  'internal.done.text': 'The request has been added to the Project’s Grievance Mechanism.',
  'internal.done.evidence': 'Reception evidence attached',
  'internal.done.give': 'Give this code to the requester. It will let them check the status of their request later.',
  'internal.done.important': 'Important: keep this code with the request information. It is the identifier used for follow-up.',
  'internal.done.anonymous': 'If the request is anonymous, this code is the only way to check its status.',
  'internal.done.view': 'View registered request',
  'internal.done.another': 'Register another request',

  // Entry pages of the two staff forms
  'entry.request.title': 'REGISTER A REQUEST RECEIVED THROUGH ANOTHER CHANNEL',
  'entry.request.intro': 'Add to the system a question, suggestion, complaint or grievance received by the Project through another channel.',
  'entry.request.new': 'Register a new request',
  'entry.request.newHint': 'Enter the details of the request received to generate its tracking code.',
  'entry.request.query': 'View registered requests',
  'entry.request.queryHint': 'Look up a request by code, date or handling status.',
  'entry.request.whatTitle': 'Which requests should you register?',
  'entry.request.whatText': 'All questions, suggestions, concerns, complaints or grievances related to the Project received through other channels, for example: physical mailboxes, complaints books, in-person service (technical visits or events), e-mail, website, phone or other approved means.',
  'entry.event.title': 'REGISTER AN EVENT',
  'entry.event.intro': 'Only add finished events to the system. Have at hand the scanned attendance list, up to 3 photos and, if applicable, the minutes, video or any other verification means.',
  'entry.event.new': 'Register an event',
  'entry.event.newHint': 'Enter the details of the finished event.',
  'entry.event.query': 'View registered events',
  'entry.event.queryHint': 'Search by organisation and event date.',

  // Events
  'component.DISTRIBUCION_CARBONO': 'Carbon benefit sharing',
  'component.MACQR': 'Grievance mechanism (MACQR)',
  'technical.REUNION_TECNICA': 'Monthly technical meeting',
  'fev.intro': 'Only add finished events to the system. Have at hand the scanned attendance list, up to 3 photos and, if applicable, the minutes, video or any other verification means.',
  'fev.who': 'Who is registering?',
  'fev.reportedByName': 'Name of the project staff member registering the event',
  'fev.reportedByEmail': 'E-mail of the project staff member registering the event',
  'fev.contractWave': 'Contract or wave related to the event',
  'fev.teamHelp': 'Fill in at least one field: project technical team members (all entities) who took part in the event. They are already included in the total number of participants.',
  'fev.attachments.beforeRegister': 'Verification files must be attached before registering the event. The attendance list is mandatory; add photos (maximum 3) and, if applicable, minutes, video or other documents.',
  'fev.attachments.attendanceRequired': 'Attach at least the scanned attendance list.',
};
